import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const businessTypeApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/shop/businessType",
      params,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/shop/businessType",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/shop/businessType/${id}`,
      method: "patch",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/shop/businessType/${id}`,
      method: "delete",
    }),
};
